"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelFieldTrueSize = exports.ModelMutatorTrueSize = void 0;
const core_api_1 = require("@ikegps/core-api");
const collection_field_1 = require("../collection.field");
class ModelMutatorTrueSize extends collection_field_1.ModelMutator {
    add(captureId) {
        const stateValue = this.field.stateValue != null ? this.field.stateValue.slice() : [];
        if (stateValue.find((cId) => captureId === cId)) {
            return;
        }
        stateValue.push(captureId);
        this.state.setFieldValue(this.field.id, stateValue);
    }
    copy(from) {
        for (const capture of from.getCaptures()) {
            this.add(capture.objectId);
        }
        return true;
    }
    clear() {
        const collection = this.field.collection;
        const usedCaptures = this.getUsedCaptures();
        for (const capture of this.field.getCaptures()) {
            const drawableState = collection.getDrawableState(capture.objectId);
            // Don't remove markers if TS capture is used by another field
            if (drawableState != null && !usedCaptures[capture.objectId]) {
                drawableState.clear();
            }
        }
        this.state.setFieldValue(this.field.id, null);
    }
    getUsedCaptures() {
        const usedCaptures = {};
        const captureIds = this.state.getFieldValue(this.field.id);
        if (captureIds == null || captureIds.length === 0) {
            return usedCaptures;
        }
        const collection = this.field.collection;
        collection.forEachField((currentField) => {
            if (!CollectionModelFieldTrueSize.isTrueSizeField(currentField) || currentField.id === this.field.id) {
                return;
            }
            const currentCaptures = currentField.getCaptures();
            for (const currentCapture of currentCaptures) {
                if (captureIds.indexOf(currentCapture.objectId) !== -1) {
                    usedCaptures[currentCapture.objectId] = true;
                }
            }
        });
        return usedCaptures;
    }
}
exports.ModelMutatorTrueSize = ModelMutatorTrueSize;
class CollectionModelFieldTrueSize extends collection_field_1.CollectionModelField {
    static isTrueSizeField(f) {
        return f.schema.type === CollectionModelFieldTrueSize.TYPE;
    }
    get Mutator() {
        if (this._Mutator == null) {
            this._Mutator = new ModelMutatorTrueSize(this);
        }
        return this._Mutator;
    }
    get value() {
        const captureIds = this.stateValue || [];
        const output = [];
        for (const captureId of captureIds) {
            const capture = this.collection.state.getCapture(captureId);
            if (capture == null) {
                throw new Error(`Field "${this.id}": Cannot find capture ${captureId}`);
            }
            output.push(capture);
        }
        return output;
    }
    getOwnedCaptures() {
        return this.getCaptures();
    }
    getCaptures() {
        return this.getCaptureIds()
            .map((c) => this.collection.state.getCapture(c))
            .filter((c) => !!c); // Handle fetchable returning "null" when race conditions occur
    }
    getOwnedCaptureIds() {
        return this.getCaptureIds();
    }
    getCaptureIds() {
        const stateValue = this.stateValue;
        if (stateValue == null) {
            return [];
        }
        return this.stateValue;
    }
    hasValue() {
        return this.value.length > 0;
    }
}
exports.CollectionModelFieldTrueSize = CollectionModelFieldTrueSize;
CollectionModelFieldTrueSize.TYPE = core_api_1.IkeFieldType.TRUE_SIZE;
//# sourceMappingURL=true.size.field.js.map